
/* global fetch */

export var LoaderUtil = {
	
	loadView: function(element, url){
		
		fetch(url)
		.then(function(response) {
			return response.text();
		})
		.then(function(content){
			element.innerHTML = content;
			var scripts = element.getElementsByTagName('script');
			for (var n = 0; n < scripts.length; n++) {
				 eval(scripts[n].innerHTML);
			}
		});
		
	},
	
	downloadFile: function(url) {
		window.location.href = url;
	}
	
};


